export default function getBackgroundColor(value) {
  if (value >= 1 && value <= 2) {
    return 'rgb(62, 91, 194)';
  }
  if (value >= 2 && value <= 10) {
    return 'rgb(117, 62, 194)';
  }
  return 'rgb(222, 139, 3)';
}
